import { render, staticRenderFns } from "./CommodityPrice.vue?vue&type=template&id=0bcfe826&"
import script from "./CommodityPrice.vue?vue&type=script&lang=js&"
export * from "./CommodityPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports